export default {
  styleOverrides: {
    paperFullScreen: {
      margin: '8px',
      height: 'calc(100% - 16px)',
    },
  },
};
